// Google Analytics 4 ヘルパー関数

// ページビュー送信
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

// コンバージョンイベント送信
export const trackConversion = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      ...parameters,
      event_category: 'conversion',
      event_label: eventName
    });
  }
};

// カスタムイベント送信
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// フォーム送信追跡
export const trackFormSubmit = (formName, formData = {}) => {
  trackEvent('form_submit', {
    form_name: formName,
    event_category: 'engagement',
    ...formData
  });
};

// 予約完了追跡
export const trackReservationComplete = (reservationData) => {
  trackConversion('reservation_complete', {
    value: 2200, // 1時間の基本料金
    currency: 'JPY',
    ...reservationData
  });
};

// お問い合わせ完了追跡
export const trackContactComplete = (contactData) => {
  trackConversion('contact_complete', {
    event_category: 'lead',
    ...contactData
  });
};

// クリックイベント追跡
export const trackClick = (elementName, elementType = 'button') => {
  trackEvent('click', {
    element_name: elementName,
    element_type: elementType,
    event_category: 'engagement'
  });
};

// スクロール追跡
export const trackScroll = (percentage) => {
  trackEvent('scroll', {
    percent_scrolled: percentage,
    event_category: 'engagement'
  });
};

// 外部リンククリック追跡
export const trackOutboundLink = (url) => {
  trackEvent('click', {
    link_url: url,
    link_domain: new URL(url).hostname,
    outbound: true,
    event_category: 'engagement'
  });
};